import { useContext, useEffect } from 'react'
import { useShallow } from 'zustand/react/shallow'

import { useDict } from '@api/dict/state'
import { useValue } from '@hooks/useValue'

import { CardCommercialOffersGenerateDoc } from './ui'
import { ICardCommercialOffersGenerateDoc, ICardCommercialOffersGenerateDocContainer, ICommercialOfferDocumentsList } from './types'

import { NotificationContext, notifyOpen } from '@ui/notification/notification.provider'


/** Контейнер - Создание документов по коммерческому предложению */
export const CardCommercialOffersGenerateDocContainer = ({isOpen, handleButtonOk, handleButtonCancel}: ICardCommercialOffersGenerateDocContainer) => {
    const notify = useContext(NotificationContext)

    /** Список доступных документов для формирования */
    const documentsList = useValue<ICommercialOfferDocumentsList[]>([])
    const {isLoading, actionGetCommercialOffersDocuments} = useDict(useShallow((state) => state))

    //===============================================================================================

    useEffect(() => {
        if (isOpen) {
            actionGetCommercialOffersDocuments().then((res) => {
                if (res) {
                    documentsList.setValue(res.map((item) => ({
                        id: item.commercialOffersDocumentID,
                        name: item.commercialOffersDocumentName,

                        isSelect: item.commercialOffersDocumentID === 1 ? true : false
                    })))
                }
            })
        }

        !isOpen && documentsList.setValue([])
    }, [isOpen]) // eslint-disable-line react-hooks/exhaustive-deps

    //===============================================================================================

    /** Функция по выбору документов */
    const handleSelectedDocuments = (docID: number) => {
        const newList = documentsList.value.map(item => {
            if (item.id === docID) {
                return { ...item, isSelect: !item.isSelect }
            }

            return item
        })
        
        documentsList.setValue(newList)
    }
    
    /** Кнопка сформировать */
    const handleBtnSave = () => {
        const newList = documentsList.value.filter((item) => item.isSelect === true)
        if (newList.length === 0) return notify && notifyOpen('Необходимо выбрать документы для формирования.', 'warning', 2000, notify)

        handleButtonOk && handleButtonOk(newList)
    }

    //===============================================================================================
    
    /** Свойства передаваемые в компоненту */
    const propsToComponent: ICardCommercialOffersGenerateDoc = {
        isOpen, isLoading, documentsList, 
        handleSelectedDocuments, 
        handleBtnSave, handleButtonCancel
    }
    
    return <>
        <CardCommercialOffersGenerateDoc {...propsToComponent} />
    </>
}